import React, { useState } from 'react';
import { Video, X } from 'lucide-react';

const MAX_FILE_SIZE_GB = 5;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_GB * 1024 * 1024 * 1024; // 5GB in bytes

function VideoUploadInput({ videoFile, setVideoFile }) {
  const [isDragActive, setIsDragActive] = useState(false);
  const [error, setError] = useState("");

  // Derive fileName from the videoFile prop
  const fileName = videoFile?.name || "";

  const validateAndSetFile = (file) => {
    setError("");

    if (!file.type.startsWith('video/')) {
      setError('Please select a video file.');
      return false;
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      const fileSizeGB = (file.size / (1024 * 1024 * 1024)).toFixed(2);
      setError(`File size (${fileSizeGB}GB) exceeds the ${MAX_FILE_SIZE_GB}GB limit.`);
      return false;
    }

    setVideoFile(file);
    return true;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragActive(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragActive(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragActive(false);
    const file = event.dataTransfer.files[0];
    if (file) {
      validateAndSetFile(file);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      validateAndSetFile(file);
    }
  };

  const handleRemoveFile = (e) => {
    e.stopPropagation();
    setVideoFile(null);
    setError("");
  };

  return (
    <div className="video-upload-input">
      <label htmlFor="video-upload">Upload Video</label>
      <div
        className={`drop-zone ${isDragActive ? 'drag-active' : ''} ${fileName ? 'file-selected' : ''}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => !fileName && document.getElementById('video-upload-hidden').click()}
      >
        {fileName ? (
          <div className="drop-zone-selected-compact">
            <div className="drop-zone-file-box">
              <Video size={28} />
              <button
                type="button"
                className="drop-zone-remove-btn-compact"
                onClick={handleRemoveFile}
                aria-label="Remove file"
              >
                <X size={14} />
              </button>
            </div>
            <span className="drop-zone-file-name-compact">{fileName}</span>
          </div>
        ) : (
          <>
            <p>Drag & Drop your video here or click to select</p>
            <p className="drop-zone-hint">MP4, MOV, WEBM up to 5GB</p>
          </>
        )}
        {error && <p className="drop-zone-error">{error}</p>}
        <input
          type="file"
          id="video-upload-hidden"
          accept="video/*"
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
      </div>
    </div>
  );
}

export default VideoUploadInput;
